<script setup lang="ts">
  import {Model} from "@/app/Model";
  import {FiltriPenale, PenaleAdmin} from "@/app/data/PenaleAdmin";

  let model: Model = Model.getReactiveInstance();
  const emit = defineEmits(["recalc"]);

  function handleSubmit(): void {
    //resetto per evitare di portarmi dietro l'offset se sono andato avanti con la paginazione
    model.pen_admin.paginazionePenale_start = 0;

    emit("recalc");
  }
  function resetFiltri(): void {
    model.pen_admin.filtriPenale = new FiltriPenale();
    handleSubmit();
  }
</script>

<template>
<div class="admin-filtri mb-2 row">
  <div class="col-4 mb-2">
    <label for="filtri_idDocMaster">ID Doc Master</label>
    <input type="number" class="form-control" id="filtri_idDocMaster" v-model.number="model.pen_admin.filtriPenale.id_doc_master">
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_idStatoSen">Status</label>
    <select class="form-select" id="filtri_idStatoSen" v-model="model.pen_admin.filtriPenale.id_stato_sen">
      <option v-for="(item, index) in PenaleAdmin.stati_sentenze" :value="item.stato" :key="'stato_'+item.stato">{{ item.label }}</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_capoImputazioneLegge">Capo Imputazione</label>
    <input type="text" class="form-control" id="filtri_capoImputazioneLegge" v-model="model.pen_admin.filtriPenale.capo_imputazione_legge">
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_assoluzione">Assoluzione</label>
    <select class="form-select" id="filtri_assoluzione" v-model="model.pen_admin.filtriPenale.assoluzione">
      <option value="">Tutti</option>
      <option v-for="(item, index) in Model.lista_esito_del_processo" :value="item" :key="'esito_'+item">{{ Model.lista_esito_del_processo_labels[index] }}</option>
    </select>
  </div>

  <div class="col-4 mb-2 not-visible">
    <label for="filtri_dataPronunciaSentenza">Data Pronuncia</label>
    <input type="date" class="form-control" id="filtri_dataPronunciaSentenza" v-model="model.pen_admin.filtriPenale.data_pronuncia_sentenza">
  </div>

  <div class="col-4 mb-2">
    <label for="filtri_modificaManuale">Modifica Manuale</label>
    <select class="form-select" id="filtri_modificaManuale" v-model="model.pen_admin.filtriPenale.modifica_manuale">
      <option value="">Tutti</option>
      <option value="true">Modificati</option>
      <option value="false">Non modificati</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_sortField">Ordinamento: Campo</label>
    <select class="form-select" id="filtri_sortField" v-model="model.pen_admin.filtriPenale.sort_field">
      <option v-for="(item) in PenaleAdmin.sort_fields" :value="item" :key="'field_'+item">{{ item }}</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_sortOrder">Ordinamento: Direzione</label>
    <select class="form-select" id="filtri_sortOrder" v-model="model.pen_admin.filtriPenale.sort_order">
      <option value="DESC">DESC</option>
      <option value="ASC">ASC</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <div>&nbsp;</div>
    <button type="button" class="btn btn-primary me-1" @click="handleSubmit()">Filtra</button>
    <button type="button" class="btn btn-sm btn-secondary" @click="resetFiltri()">Reset</button>
  </div>
</div>
</template>